import React, { useEffect } from 'react'

import Bar from './Bar'
import useAudioPlayer from './useAudioPlayer'

function Audio({
  audioSources,
  musicVolume,
  bgVolume,
  volume,
  soundDuration,
  singleAudio
}) {
  const { curTime, duration, playing, setPlaying, setClickedTime } =
    useAudioPlayer()

  const audioContainer = document.getElementById('spoken')
  const audioContainer2 = document.getElementById('bgMusic')
  const singleAudioContainer = document.getElementById('singleAudio')

  useEffect(() => {
    if (audioContainer) {
      audioContainer.volume = musicVolume / 100
    }
    if (audioContainer2) {
      audioContainer2.volume = bgVolume / 100
    }
    if (singleAudioContainer) {
      singleAudioContainer.volume = volume / 100
    }
  }, [
    musicVolume,
    audioContainer,
    bgVolume,
    audioContainer2,
    volume,
    singleAudioContainer
  ])

  return (
    <div id='player'>
      <div id='audio-sources'>
        {Object.keys(audioSources).map((key, index) => (
          <audio id={key} key={index}>
            <source src={audioSources[key]} />
            Your browser does not support the <code>audio</code> element.
          </audio>
        ))}
      </div>

      <div className='controls'>
        <Bar
          curTime={curTime}
          duration={duration}
          onTimeUpdate={time => setClickedTime(time)}
        />
        <div className='d-flex align-items-center justify-content-center'>
          <button
            className='player__button'
            onClick={() =>
              setTimeout(() => {
                if (audioContainer && audioContainer2) {
                  audioContainer.pause()
                  audioContainer2.pause()
                  audioContainer.currentTime = 0
                  audioContainer2.currentTime = 0
                } else if (singleAudioContainer) {
                  singleAudioContainer.pause()
                  singleAudioContainer.currentTime = 0
                }
              }, 100)
            }
          >
            <i className='bi bi-arrow-counterclockwise'></i>
          </button>
          {playing ? (
            <button
              className='player__button'
              onClick={() => setPlaying(false)}
            >
              <i className='bi bi-pause'></i>
            </button>
          ) : (
            <button className='player__button' onClick={() => setPlaying(true)}>
              <i className='bi bi-play'></i>
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default Audio
